const loading = document.querySelector('.container-loading');
const contentArticles = document.querySelector('.content-card-author');

const contentPagination = document.querySelector('.pagination-author');
const contentPaginationItems = document.querySelector('.container-number');
let numbersPagination = [];

const articlesEl = document.querySelector('#articles-json');
const articles = articlesEl ? JSON.parse(articlesEl.textContent) : [];

let page = 1;
let per_page = 8;
let total = articles.length / per_page;

document.addEventListener('DOMContentLoaded', function () {
  if (total > 1) {
    for (i = 1; i <= total; i++) {
      contentPaginationItems.innerHTML += `
        <span class='number-pagination ${page === i ? 'active' : ''}'>${i}</span>
      `;
    }
    contentPagination.classList.remove('none');
    numbersPagination = document.querySelectorAll('.number-pagination');

    numbersPagination.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        setPage(e.target.innerText);
      });
    });

    const arrowPrev = document.querySelector('.arrow.prev');
    if (arrowPrev) {
      arrowPrev.addEventListener('click', (e) => {
        e.preventDefault();

        if (page <= 1) return;

        setPage(page - 1);
      });
    }

    const arrowNext = document.querySelector('.arrow.next');
    if (arrowNext) {
      arrowNext.addEventListener('click', (e) => {
        e.preventDefault();

        if (page >= total) return;

        setPage(page + 1);
      });
    }
  }

  setPage(page);
});

function setPage(newPage) {
  numbersPagination.forEach((item) => item.classList.remove('active'));

  page = parseInt(newPage);
  const selectedNumber = numbersPagination[page - 1];
  if (selectedNumber) {
    selectedNumber.classList.add('active');
  }

  loading.classList.remove('none');
  contentArticles.classList.add('none');
  contentArticles.innerHTML = '';

  const start = (page - 1) * per_page;
  const end = start + per_page;

  const paginatedItems = articles.slice(start, end);
  if (paginatedItems.length > 0) {
    contentArticles.innerHTML = paginatedItems.map(
      (item) => `<div class="card-author">
        <a href="${item.url}">
          <h4>${item.title}</h4>
          <img src="${item.image.src}" alt="${item.image.alt}">
          <span>By ${item.author}</span>
          <span>${item.createdAt} </span>
        </a>
      </div>`,
    );
  }

  setTimeout(() => {
    loading.classList.add('none');
    contentArticles.classList.remove('none');
  }, 300);
}
